import React from 'react';
import SidebarWrapper from '../../Sidebar/UserSidebar/SidebarWrapper';

const Settings = () => {
    return (
        <SidebarWrapper>
            <h2>Settings page for user has not been implemented yet</h2>
        </SidebarWrapper>
    )
}

export default Settings;